import {useUpdateMonitorTags} from 'entities/monitor';
import {serverAPI} from 'features/server/api/serverAPI';

export const useUpdateServerTags = (uuid: string | undefined) => {
    const [updateServer] = serverAPI.useUpdateServerMutation();

    return useUpdateMonitorTags(updateServer, uuid);
};

export default useUpdateServerTags;
